<template>
    <div class="productAddWrapBatch11">
        <div class="selectWrap">
            <span class="warningLabel"> <span class="red"> *</span> 请先选择上传商品所属公司：</span>
            <el-select placeholder="公司" v-model="currentSelectCompany" >
                <el-option :label="list.text" :value="list.value"    v-for="(list,index) in companyWord" :key="index"></el-option>
            </el-select>
        </div>
        <!-- 
                 class="upload-demo"  drag
            :action="uploadUrl"
             name="file"
             :data="fileData"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :on-success="onSuccess"
            :on-error="onError"
            accept=".zip"
         -->
        <div class="uploadWrap">
            <el-upload 
                class="upload-demo"
                drag
                :action="uploadUrl"
                name="file"
                :data="fileData"
                :before-upload="beforeUpload"
                :on-success="onSuccess"
                :on-error="onError"
                :on-progress="onProgress"
                accept=".zip"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">注：只能上传.zip文件，且不超过500M</div>
            </el-upload>
        </div>
        <div class="example">
            参考示例： 请点击 <a :href="exampleUrl" class="example-link"><i class="el-icon-download"></i> 批量上传商品示例</a> 下载查看
        </div>
        
        <el-dialog title="上传提示" :visible.sync="uploadBugTipsVisible" width="50%" :close-on-click-modal="false">
            <p class="upload-bug-table-tip">文件上传成功，但文件内容格式有误，详细说明请 <a href="javascript:;" style="color: #409EFF; text-decoration: underline" @click="uploadExcelOfError">下载excel</a> 进行查看。</p>
        </el-dialog>

        <div class="mask" v-show="waitingLoading">
            <div class="content">
                <i class="el-icon-loading"></i>
                服务端正在处理，请稍候...
            </div>
		</div>

        <el-dialog title="上传提示" :visible.sync="uploadBugTableVisible" width="70%" :close-on-click-modal="false" :show-close="false">
            <p class="upload-bug-table-tip">文件上传成功，但出现部分重复数据，显示如下（您也可以通过 <a href="javascript:;" style="color: #409EFF; text-decoration: underline" @click="uploadExcelOfRepeat">下载excel</a> 查看详细说明）：</p>
            <el-table :data="bugList" v-loading="listLoading" border empty-text="暂无数据" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50">
                </el-table-column>
                <el-table-column prop="number" label="序号" width="60">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="itemMainImagePath" label="图片">
                    <template slot-scope="scope">
                        <img class="goods-img" :src="scope.row.itemMainImagePath | imgUrlTransform" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="itemName" label="商品名称">
                    <template slot-scope="scope">
                        {{ scope.row.itemName }}
                    </template>
                </el-table-column>
                <el-table-column prop="itemSectionNumber" label="款号">
                    <template slot-scope="scope">
                        {{ scope.row.itemSectionNumber}}
                    </template>
                </el-table-column>
                <el-table-column prop="itemColorName" label="颜色">
                    <template slot-scope="scope">
                        {{ scope.row.itemColorName }}
                    </template>
                </el-table-column>
                <el-table-column prop="itemSizeNames" label="尺码">
                    <template slot-scope="scope">
                        {{ scope.row.itemSizeNames }}
                    </template>
                </el-table-column>
                <el-table-column prop="itemOrderPrice" label="订货价（元）">
                    <template slot-scope="scope">
                        {{ scope.row.itemOrderPrice }}
                    </template>
                </el-table-column>
                <el-table-column prop="itemOriginalPrice" label="吊牌价（元）">
                    <template slot-scope="scope">
                        {{ scope.row.itemOriginalPrice }}
                    </template>
                </el-table-column>
                <el-table-column prop="itemUserCategory" label="类目">
                    <template slot-scope="scope">
                        {{ scope.row.itemUserCategory }}
                    </template>
                </el-table-column>
                <el-table-column prop="itemBrandName" label="所属品牌">
                    <template slot-scope="scope">
                        {{ scope.row.itemBrandName }}
                    </template>
                </el-table-column>
                <el-table-column prop="itemIsRecommend" label="是否为主推款">
                    <template slot-scope="scope">
                        {{scope.row.itemIsRecommend == 'y' ? '是' : '否'}}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitRepeatDate">确 定</el-button>
            </span>
            <p style="margin-top: 15px;">注：针对每条数据，勾选左侧复选框，点击 “确定” 按钮，会覆盖原有数据；不勾选左侧复选框，点击 “确定” 按钮，则忽略该条数据</p>
        </el-dialog>
    </div>
</template>

<script>
    import {json,wordData,utils} from '@/common/common.js'
    import axios from 'axios'
    import {api,ajaxPost,ajaxBrand} from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                fileData: {
                  data: ''
                },
                conferenceId:'',
                companyWord:[],
                currentSelectCompany:'',
                percentage:0,
               
                uploadBugTableVisible: false,
                bugList: [],
                selectBugList: [],
                waitingLoading: false,
                listLoading: true,
                // goodsRepeatSubmitCount: 0,
                // goodsRepeatSubmitSuccessCount: 0,
                uploadBugTipsVisible: false,

                exampleUrl: api.imgPrev + '/download/order_conference/sample.zip'
            }
        },
        computed:{
            uploadUrl(){
                return api.baseUrlBrand +'/ordering_system_admin/file/itemUploadFile'
            }
        },
        methods: {
            onSuccess(res, file, fileList) {
                console.log('on-success-response', res)
                console.log('on-success-file', file)
                console.log('on-success-fileList', fileList)
                this.waitingLoading = false;
                if(res.erroyCode === 200) {
                    if (!res.dto && !res.data) {
                        this.$message({
                            type: 'success',
                            message: '文件上传成功'
                        })
                        this.$router.go(-1);
                    } else if (res.dto && res.dto.length > 0) {
                        // this.$message({
                        //   type: 'warning',
                        //   message: '文件上传成功, 但出现重复数据'
                        // })
                        this.uploadBugTableVisible = true;
                        this.bugList = res.dto.map(item => {
                            return {
                            ...item,
                            itemMainImagePath: item.itemMainImagePath.replace(/\/share/, '')
                            }
                        });
                        this.listLoading = false;
                    }
                } else if (res.erroyCode === -10001) {
                    fileList.pop();
                    this.uploadBugTipsVisible = true;
                } else {
                    fileList.pop();
                    this.$message({
                        type: 'error',
                        message: res.erroyMsg
                    })
                }
            },
            onError(err, file, fileList) {
                this.waitingLoading = false;
                this.$message({
                    type: 'error',
                    message: '文件上传失败'
                })
            },
            onProgress(event, file, fileList) {
                this.percentage = event.percent;
                console.log("上传中")
                if (event.percent == 100) {
                    this.waitingLoading = true;
                }

            },
            beforeUpload(file) {
                if(!this.conferenceId){
                    alert("没有选择活动，无法上传")
                    return false
                }
                if(!this.currentSelectCompany){
                    alert("请先选择商品所属公司")
                    return false
                }
                console.log('before-upload-file', file)
                this.fileData.data = JSON.stringify({
                    userId : this.currentSelectCompany,
                    conferenceId: this.conferenceId
                })
                if (!(file.type === 'application/zip' || file.type === 'application/x-zip-compressed')) {
                    this.$message({
                    type: 'warning',
                    message: '文件类型必须为.zip格式!'
                    })
                    return false
                } else if (file.size > 500 * 1024 * 1024) {
                    this.$message({
                    type: 'warning',
                    message: '文件大小不能超过500M!'
                    })
                    return false
                }
            },
            getCompanyOption(){
                let _this=this
                let arg={
                    conferenceId:_this.conferenceId,
                }
                ajaxPost('/admin/companylist', arg).then(function(res) {
                    if(res.errorCode==200){
                        let resData=res.data?res.data:[]
                        _this.companyWord=resData.map(function(item,index){
                            let buffer={
                                text:item.companyName,
                                value:item.userId,
                            }
                            return buffer
                        })
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                console.log(this.$route.params)
            },
            submitRepeatDate() {
                if(this.selectBugList.length == 0) {
                    this.$confirm('您将忽略列表中的所有数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.uploadBugTableVisible = false
                        this.$router.go(-1)
                    }).catch(() => {
                        //...
                    })
                }
                if (this.selectBugList.length > 0) {
                    this.$confirm('您将覆盖'+ this.selectBugList.length +'条数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
				    }).then(() => {
                        this.waitingLoading = true;
                        for(let i = 0; i < this.selectBugList.length; i ++ ) {
                            this.submitGoodsData(this.selectBugList[i]);
                        }
                        let submitArray = this.selectBugList.map(item => {
                            return  function () { return this.submitGoodsData(item)};
                        })
                        Promise.all(submitArray).then(arr => {
                            console.log(arr);
                            this.$message({
                                type: 'success',
                                message: `已全部处理完成,将返回商品列表页`
                            })
                            setTimeout(() => {
                                this.waitingLoading = false;
                                this.$router.go(-1)
                            }, 1000);
                        }, error => {
                            console.log('error', error);
                            this.$message({
                                type: 'error',
                                message: `商品覆盖失败!`
                            })
                            this.waitingLoading = false;
                        })
                    }).catch(() => {
                        //...
                    })
                }
            },
            submitGoodsData(item) {
                return new Promise((resolve, reject) => {
                    ajaxBrand('ordering_system_admin/mallitem/updateMallItem', {
                        data: JSON.stringify({
                            conferenceId: this.conferenceId,
                            brandId: this.currentSelectCompany,
                            itemId: item.duplicateColorId,
                            itemName: item.itemName,
                            styleNumber: item.itemSectionNumber,
                            colorName: item.itemColorName,
                            sizeNames: item.itemSizeNames.replace(/\s+/g, ','),
                            categoryName: item.itemUserCategory,
                            itemOriginalPrice: item.itemOriginalPrice,
                            itemOrderPrice: item.itemOrderPrice,
                            brandName: item.itemBrandName,
                            itemIsRecommend: item.itemIsRecommend,
                            images: item.itemDetailImagePath ? item.itemMainImagePath + '|'+ item.itemDetailImagePath : item.itemMainImagePath
                        })
                    }).then((res) => {
                        console.log(999)
                        console.log(res);
                        if(res.erroyCode === 200) {
                            resolve(item)
                        } else {
                            reject(item)
                        }
                    }).catch(() => {
                        reject(item)
                    })
                })
            },
            uploadExcelOfError() {
                ajaxBrand('ordering_system_admin/file/uploadItemsExportHttp', {
                    data: JSON.stringify({
                        userId: this.currentSelectCompany
                    })
                }).then(response => {
                    console.log(response)
                    console.log(api.imgPrev + '' + response)
                    let load_url = response.replace(/\/share/, '');
                    location.href = api.imgPrev + '' + load_url
                }).catch(error => {
                    this.$message({
                        type: 'error',
                        message: '下载excel失败'
                    })    
                })
            },
            uploadExcelOfRepeat() {
                ajaxBrand('ordering_system_admin/file/uploadItemsRepeatExportHttp', {
                    data: JSON.stringify({
                        userId: this.currentSelectCompany
                    })
                }).then(response => {
                    console.log(response)
                    console.log(api.imgPrev + '' + response)
                    let load_url = response.replace(/\/share/, '');
                    location.href = api.imgPrev + '' + load_url
                }).catch(error => {
                    this.$message({
                        type: 'error',
                        message: '下载excel失败'
                    })    
                })
            },
            handleSelectionChange(val) {
            console.log(val);
            this.selectBugList = val;
            }
        },
        mounted(){
            this.getParams()
            this.getCompanyOption()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .productAddWrapBatch11 {
        .warningLabel{font-size: 20px;font-weight: bold;}
        .selectWrap{padding:20px 10px;}
        .uploadWrap{padding:20px; background: #fff; width: 450px; border-radius: 4px; margin: 0 0 0 20px;}
        .progressWrap{width: 400px;}
        .buttonWrap{padding:10px;padding-top:30px;}
        .batch-upload-title {padding:10px 0 20px; font-size: 15px;}
        .batch-upload-area {width: 360px; padding-bottom: 30px;}
        .upload-bug-table-tip {margin-bottom: 15px; font-size: 14px; color: #E6A23C}
        .goods-img {
        width: 80px;
        }
        .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #000000, $alpha: 0.8);
        z-index: 99999;
            .content {
                margin-top: 20%;
                text-align: center;
                height: 100px;
                font-size: 18px;
                color: #ccc;
                i {
                    font-size: 30px;
                    vertical-align: middle;
                }
            }
        }
        .example {
            margin: 20px;
            font-size: 14px;
            color: #000;
            .example-link {
                color: #409EFF;
                text-decoration: underline;
                i {
                font-size: 20px;
                vertical-align: middle;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/productAddBatch.vue